import { Switch, Route } from 'react-router-dom';

import { OMenuItem } from 'lib/omnibar';

import Home from 'Home';
import Article from 'Article';
import Search from 'Search';

interface Props {
  className?: string;
  items?: OMenuItem[];
  onSearch: (searchTerm: string) => void;
}

const Router = ({ className, items, onSearch }: Props) => (
  <div className={className} id="router">
    <Switch>
      <Route path={['/article/:articleId/*', '/article/:articleId']}>
        <Article />
      </Route>
      <Route path="/search">
        <Search />
      </Route>
      <Route path="/">
        <Home items={items} onSearch={onSearch} />
      </Route>
    </Switch>
  </div>
);

export default Router;
